module.exports = __webpack_public_path__ + "img/logo.f0fad040.png";